import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { withTheme } from 'styled-components';
import { Text, Select, ListItem, Checkbox } from '@movember/mo-gel/';
import { normaliseColor } from '@movember/mo-gel/utils/colors';
import { StyledSelectContainer, StyledHeading, StyledRadio, StyledHeadingContainer } from './QuestionAnswer.styled';

class QuestionAnswer extends Component {
  constructor(props) {
    super(props);
    const { input } = this.props;

    this.state = {
      disableSelect: input.name === 'ltc_group' && input.selectedValue && input.selectedValue.itemKey === 0
    };
  }

  onNoOtherConditionsCheck = (event, value) => {
    const { onItemSelect } = this.props;
    this.setState({ disableSelect: value });
    if (value && onItemSelect) onItemSelect(event, 0);
  };

  render() {
    const { input, onItemSelect, name, theme } = this.props;
    const { disableSelect } = this.state;
    const { question, subOptionsQuestion, info, options } = input;
    let { selectedValue } = input;

    let isOptionsBoolean;
    if (options && options.length === 2) {
      isOptionsBoolean = ['Yes', 'No'].includes(options[0].text) && ['Yes', 'No'].includes(options[1].text);
    }

    const showRadio = input.name === 'stage' || input.name === 'age_band' || isOptionsBoolean;

    if (!selectedValue) {
      selectedValue = {
        text: `Select ${input.label ? input.label.toLowerCase() : ''}`,
        itemKey: 0
      };
    }

    return (
      <>
        {info && (
          <Text display="block" marginBottom="1rem">
            {input.info}
          </Text>
        )}
        <StyledHeadingContainer>
          <StyledHeading>{question || subOptionsQuestion}</StyledHeading>
        </StyledHeadingContainer>
        {showRadio && (
          <>
            {options.length > 0 &&
              options.map((item, index) => {
                return (
                  <StyledRadio
                    key={`radio-item-${index}`}
                    name={input.name || item.name}
                    onChange={(event) => onItemSelect(event, parseInt(event.target.value, 10))}
                    value={item.itemKey}
                    isSelected={selectedValue.itemKey === item.itemKey}
                  >
                    <Text fontWeight="bold">{item.text}</Text>
                  </StyledRadio>
                );
              })}
          </>
        )}
        <StyledSelectContainer>
          {!showRadio && (
            <Select
              name={input.name || name}
              placeholder={selectedValue.text}
              value={selectedValue.itemKey}
              onChange={(event, value) => onItemSelect(event, value)}
              width="100%"
              disabled={disableSelect}
              multiple={input.inputType === 'multipleSelect'}
              styleAs="pill"
              height={input.name === 'ltc_group' ? '480px' : 'auto'}
            >
              {options.length > 0 &&
                options.map((item, index) => {
                  return (
                    <ListItem
                      key={`list-item-${index}`}
                      itemKey={item.itemKey}
                      selected={item.selected}
                      styleFor="pill"
                    >
                      <Text>{item.text}</Text>
                    </ListItem>
                  );
                })}
            </Select>
          )}
          {input.name === 'ltc_group' && (
            <Checkbox
              name="ltc_noOtherHealthConditions"
              checked={disableSelect}
              onChange={(event, value) => this.onNoOtherConditionsCheck(event, value)}
              color={normaliseColor(theme.typography.defaultColors, theme)}
              align="left"
            >
              <Text>No other health conditions</Text>
            </Checkbox>
          )}
        </StyledSelectContainer>
      </>
    );
  }
}

const QuestionAnswerWrapper = withTheme(QuestionAnswer);
export { QuestionAnswerWrapper as QuestionAnswer };

QuestionAnswer.defaultProps = {
  input: {
    label: '',
    name: '',
    options: [],
    selectedValue: undefined,
    isRequired: false,
    question: '',
    info: ''
  },
  theme: {},
  onItemSelect: () => {}
};

QuestionAnswer.propTypes = {
  input: PropTypes.shape({ input: PropTypes.object }),
  onItemSelect: PropTypes.func,
  theme: PropTypes.shape({ theme: PropTypes.object })
};
